import React from 'react';
import { FaBars, FaExpand, FaPause, FaClock } from 'react-icons/fa';

const ExamHeader = ({
  categories,
  timeLeft,
  isFullScreen,
  onFullScreenToggle,
  onShow,
}) => {
  const topic = categories?.[0]?.topic_name || 'Online Examination';
  const isCritical = timeLeft === 'Time Up!' || /^00:0[0-5]:/.test(timeLeft || '');

  return (
    <header className="exam-header">
      <div className="exam-header__brand">
        <div className="brand-mark">E</div>
        <div>
          <div className="brand-name">ErwaToday</div>
          <div className="brand-topic">{topic}</div>
        </div>
      </div>

      <div className="exam-header__controls">
        {timeLeft && (
          <div className={`exam-timer ${isCritical ? 'exam-timer--critical' : ''}`}>
            <FaClock />
            <span className="exam-timer__label">Time left</span>
            <strong>{timeLeft}</strong>
          </div>
        )}

        <button type="button" className="header-action header-action--secondary" onClick={onFullScreenToggle}>
          <FaExpand />
          <span>{isFullScreen ? 'Exit full screen' : 'Full screen'}</span>
        </button>

        <button type="button" className="header-action header-action--secondary" onClick={() => { window.location.href = '/dashboard'; }}>
          <FaPause />
          <span>Pause</span>
        </button>

        <button type="button" className="header-action header-action--mobile" onClick={() => onShow(true)} aria-label="Open question navigator">
          <FaBars />
        </button>
      </div>
    </header>
  );
};

export default ExamHeader;
